// AUTOGENERATED FILE - DO NOT EDIT (run updatePoiIcons.js instead)
export const poiIcons = {
  'poi-camping':
   { poiType: 3,
     label: 'Camping',
     iconUrl: '/images/poi_icons/camping.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-lodging':
   { poiType: 10,
     label: 'Lodging',
     iconUrl: '/images/poi_icons/lodging.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-parking':
   { poiType: 12,
     label: 'Parking',
     iconUrl: '/images/poi_icons/parking.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-food':
   { poiType: 13,
     label: 'Food',
     iconUrl: '/images/poi_icons/food.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-viewpoint':
   { poiType: 14,
     label: 'Viewpoint',
     iconUrl: '/images/poi_icons/viewpoint.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-restroom':
   { poiType: 15,
     label: 'Restroom',
     iconUrl: '/images/poi_icons/restroom.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-generic':
   { poiType: 17,
     label: 'Generic',
     iconUrl: '/images/poi_icons/generic.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-aid-station':
   { poiType: 20,
     label: 'Aid Station',
     iconUrl: '/images/poi_icons/aidstation.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-bar':
   { poiType: 21,
     label: 'Bar',
     iconUrl: '/images/poi_icons/bar.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-bike-shop':
   { poiType: 22,
     label: 'Bike Shop',
     iconUrl: '/images/poi_icons/bikeshop.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-bike-parking':
   { poiType: 23,
     label: 'Bike Parking',
     iconUrl: '/images/poi_icons/bikeparking.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-convenience-store':
   { poiType: 24,
     label: 'Convenience Store',
     iconUrl: '/images/poi_icons/conveniencestore.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-first-aid':
   { poiType: 25,
     label: 'First Aid',
     iconUrl: '/images/poi_icons/firstaid.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-hospital':
   { poiType: 26,
     label: 'Hospital',
     iconUrl: '/images/poi_icons/hospital.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-rest-stop':
   { poiType: 27,
     label: 'Rest Stop',
     iconUrl: '/images/poi_icons/reststop.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-trailhead':
   { poiType: 28,
     label: 'Trailhead',
     iconUrl: '/images/poi_icons/trailhead.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-geocache':
   { poiType: 29,
     label: 'Geocache',
     iconUrl: '/images/poi_icons/geocache.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-water':
   { poiType: 30,
     label: 'Water',
     iconUrl: '/images/poi_icons/water.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-control':
   { poiType: 31,
     label: 'Control',
     iconUrl: '/images/poi_icons/control.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-winery':
   { poiType: 32,
     label: 'Winery',
     iconUrl: '/images/poi_icons/winery.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-start':
   { poiType: 33,
     label: 'Start',
     iconUrl: '/images/poi_icons/start.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-stop':
   { poiType: 34,
     label: 'Stop',
     iconUrl: '/images/poi_icons/stop.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-finish':
   { poiType: 35,
     label: 'Finish',
     iconUrl: '/images/poi_icons/finish.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-atm':
   { poiType: 36,
     label: 'ATM',
     iconUrl: '/images/poi_icons/atm.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-caution':
   { poiType: 37,
     label: 'Caution',
     iconUrl: '/images/poi_icons/caution.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-coffee':
   { poiType: 38,
     label: 'Coffee',
     iconUrl: '/images/poi_icons/coffee.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-ferry':
   { poiType: 39,
     label: 'Ferry',
     iconUrl: '/images/poi_icons/ferry.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-gas-station':
   { poiType: 40,
     label: 'Gas Station',
     iconUrl: '/images/poi_icons/gasstation.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-library':
   { poiType: 41,
     label: 'Library',
     iconUrl: '/images/poi_icons/library.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-monument':
   { poiType: 42,
     label: 'Monument',
     iconUrl: '/images/poi_icons/monument.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-park':
   { poiType: 43,
     label: 'Park',
     iconUrl: '/images/poi_icons/park.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-segment-start':
   { poiType: 44,
     label: 'Segment Start',
     iconUrl: '/images/poi_icons/segment.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-segment-end':
   { poiType: 45,
     label: 'Segment End',
     iconUrl: '/images/poi_icons/segmentstop.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-shopping':
   { poiType: 46,
     label: 'Shopping',
     iconUrl: '/images/poi_icons/shopping.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-shower':
   { poiType: 47,
     label: 'Shower',
     iconUrl: '/images/poi_icons/shower.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-summit':
   { poiType: 48,
     label: 'Summit',
     iconUrl: '/images/poi_icons/summit.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-swimming':
   { poiType: 49,
     label: 'Swimming',
     iconUrl: '/images/poi_icons/swimming.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-transit-center':
   { poiType: 50,
     label: 'Transit Center',
     iconUrl: '/images/poi_icons/transitcenter.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] },
  'poi-bike-share':
   { poiType: 51,
     label: 'Bike Share',
     iconUrl: '/images/poi_icons/bikeshare.png',
     iconSize:
      [ 34,
        40 ],
     iconAnchor:
      [ 17,
        40 ] }
}
